// extracted by mini-css-extract-plugin
export var callCard = "_pz-0";
export var callMessageButton = "_pz-1";
export var helpIcon = "_pz-3";
export var helpIconContainer = "_pz-4";
export var verticalDivider = "_pz-2";